import {HttpContextToken, HttpStatusCode} from "@angular/common/http";

export class HttpContextConstant {
    static readonly SKIP_ERROR_SNACKBAR: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
}

export const NETWORK_FAILURE_STATUS = 0;

export const HTTP_ERROR_MESSAGE = {
    GATEWAY_TIMEOUT: 'The server took too long to respond. Please try again.',
    SERVICE_UNAVAILABLE: 'The service is temporarily unavailable. Please try again in a moment.',
    NETWORK_FAILURE: 'Can\'t reach the server. Check your connection and try again.',
    GENERIC: 'Oops! Something went wrong.'
} as const;

export const HTTP_ERROR_MESSAGE_BY_STATUS: ReadonlyMap<number, string> = new Map<number, string>([
    [HttpStatusCode.GatewayTimeout, HTTP_ERROR_MESSAGE.GATEWAY_TIMEOUT],
    [HttpStatusCode.BadGateway, HTTP_ERROR_MESSAGE.SERVICE_UNAVAILABLE],
    [HttpStatusCode.ServiceUnavailable, HTTP_ERROR_MESSAGE.SERVICE_UNAVAILABLE],
    [NETWORK_FAILURE_STATUS, HTTP_ERROR_MESSAGE.NETWORK_FAILURE]
]);
